export const host = '/api'
// export const host = 'http://api.myjson.com/bins/67e5u';



// WEBPACK FOOTER //
// ./src/common/CommonCode.js